import React, {useState, useEffect, useContext} from 'react'
import stripeOptions from '../../services/stripe'
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { Link } from 'react-router-dom'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Divider, Form, Image, List, Accordion, Loader} from 'semantic-ui-react'
import { backendService } from '../../services/backendService'
import CardForm from './CardForm'
import { connect } from 'react-redux'
import Logo from '../../images/logo-admin.png'
import { getProjects } from '../../actions/actionCreators'
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { NotificationManager } from 'react-notifications';
import BillingInfoForm from '../BillingInfoForm'
import csc from 'country-state-city'

const UserPage = (props) => {
    const languageContext = useContext(LanguageContext);
    const [customerProfile, setCustomerProfile] = useState(null);
    const [curUser, setCurUser] = useState({
      name: '',
      surname: '',
      email: '',
      plan: '',
      is_verified: false,
      plan_queries: 500,
      license_expire_at: null,
    })

    const [showCardForm, setShowCardForm] = useState(false)
    const [withCard, setWithCard] = useState(false)
    const id = props.match.params.id
    const [ loading, setIsLoading ] = useState(false)
    const [ processing, setIsProcessing ] = useState(false)
    const [errors, setErrors] = useState({
      cardError: '',
      name: '',
      email: '',
      query: '',
      plan: '',
    })

    const [prices, setPrices] = useState({
      product_prices: [],
    })

    const [showCards, setShowCards] = useState(false)

    const [showBillingInfo, setShowBillingInfo] = useState(false)
    const [billingInfo, setBillingInfo] = useState({})
    const [coupon, setCoupon] = useState(null)
    
    ////////////////////////////////////

    useEffect(() => {           
      if (id) 
        getUser()              
    }, []) // eslint-disable-line react-hooks/exhaustive-deps 
    ////////////////////////////////////
    const getUser = async() => {
      try {
        setIsLoading(true)
        const authorization = backendService.defaults.headers.Authorization;
        const response = await backendService.get(`/api/lawyers/${id}`, {authorization})
        console.log(response);
        setCurUser(response.data)
        if (response.data) {
          props.dispatch(getProjects({ user: response.data.email, userId: response.data.id }))
          const stripe_response = await backendService.get('/api/lawyers/' + response.data.id + '/stripe_customer')
          if (stripe_response.data) {
            const stripe_customer = stripe_response.data
            let newBillingInfo = {}
            if (stripe_customer.address) {
              newBillingInfo.address = stripe_customer.address.line1
              newBillingInfo.address_complement = stripe_customer.address.line2
              newBillingInfo.state = stripe_customer.address.state
              newBillingInfo.city = stripe_customer.address.city
              newBillingInfo.zip_code = stripe_customer.address.postal_code
              newBillingInfo.country_code = stripe_customer.address.country ? stripe_customer.address.country : 'IT'
              newBillingInfo.country = csc.getCountryByCode(newBillingInfo.country_code).id
            }
            if(stripe_customer.tax_ids.data && stripe_customer.tax_ids.data[0])
              newBillingInfo.vat_number = stripe_customer.tax_ids.data[0].value
            if (stripe_customer.metadata.Pec)
              newBillingInfo.Pec = stripe_customer.metadata.Pec
            if (stripe_customer.metadata.Fe_code)
              newBillingInfo.Fe_code = stripe_customer.metadata.Fe_code
            if (stripe_customer.metadata.Fiscal_code)
              newBillingInfo.Fiscal_code = stripe_customer.metadata.Fiscal_code
            setBillingInfo(newBillingInfo)
            setCustomerProfile(stripe_customer)
          }
        }
        setIsLoading(false)
      }
      catch(error){
        const mess = Translate(languageContext, error.data.message) ? Translate(languageContext, error.data.message) : Translate(languageContext, 'generic_fail_message')
        NotificationManager.error(mess)
        setIsLoading(false)
      }
    }
    
    const ValidateEmail = (mail) =>{
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/.test(mail))
      {
        return (true)
      }
        return (false)
    }
  
    const validateUser = () => {
      const fieldsErrors = {};
      if (curUser.name === '') fieldsErrors.name = Translate(languageContext, 'signup_name_is_required');
      if (curUser.surname === '') fieldsErrors.surname = Translate(languageContext, 'signup_surname_is_required');
      if (!ValidateEmail(curUser.email)) fieldsErrors.email = Translate(languageContext, 'signup_email_is_invalid');
      if (curUser.email === '') fieldsErrors.email = Translate(languageContext, 'signup_email_is_required');
      if ( curUser.plan_queries === 'e' || curUser.plan_queries === '') fieldsErrors.query = Translate(languageContext, 'signup_queries_must_be_number');
        
      return Object.keys(fieldsErrors).length ? fieldsErrors : false;
    };

    const handleChange = (e) => {
      setErrors({...errors, [e.target.name]: ''});
      if (e.target.name === 'email') {
        setCurUser({...curUser, [e.target.name]: e.target.value.toLowerCase()})
      } else {
        setCurUser({...curUser, [e.target.name]: e.target.value})
      }
    } 

    const handleDateChange = (e, data) => {
      setCurUser({...curUser, license_expire_at: data.value})
    }

    const handleBillingInfoChanged = (billingInfo) => {
      setBillingInfo(billingInfo)
    } 

    const handleResult = async () => {
      const now = new Date()
      let trial_period = 0
      const { name, surname, email, plan, plan_queries, license_expire_at, is_verified} = curUser;

      const validateErrors = validateUser();
      if (validateErrors) {
        setErrors(validateErrors);
        return;
      }

      if (showBillingInfo && (billingInfo.is_error || !billingInfo.is_data_ok))
        return;

      if (license_expire_at)
        trial_period = Math.ceil((license_expire_at.getTime() - now.getTime()) / (1000 * 60 * 60 * 24 ))

      let req = { name, surname, email, plan_queries, is_verified , trial_period}
      if (showBillingInfo) {            
        req.address = billingInfo ? {
          line1: billingInfo.address,
          line2: billingInfo.address_complement,
          city: billingInfo.city,
          country: billingInfo.country_code,
          state: billingInfo.state,
          postal_code: billingInfo.zip_code
        } : null
        
        const metadata = billingInfo ? {
          Fe_code: billingInfo.Fe_code,
          Pec: billingInfo.Pec,
          Fiscal_code: billingInfo.Fiscal_code
        } : {}
             
        req.metadata = metadata 

        req.vat_number = billingInfo ? billingInfo.vat_number : null
        
      }
      try { 
        const res = await backendService.post('/api/lawyers', req)
        NotificationManager.success(Translate(languageContext, 'user_profile_created'));
        props.history.push('/adminpage')
      }
      catch(error){
        const mess = Translate(languageContext, error.data.message) ? Translate(languageContext, error.data.message) : Translate(languageContext, 'generic_fail_message');
        NotificationManager.error(mess)
      }
    }
    
    const handleEdit = async (e) => {
      e.preventDefault();
      setIsProcessing(true)
      const validateErrors = validateUser();
      if (validateErrors) {
        setErrors(validateErrors);
      }
      else {
        try {
          //add billing info
          let lawyer = curUser
          if (showBillingInfo) {            
            lawyer.address = billingInfo ? {
              line1: billingInfo.address,
              line2: billingInfo.address_complement,
              city: billingInfo.city,
              country: billingInfo.country_code,
              state: billingInfo.state,
              postal_code: billingInfo.zip_code
            } : null
            
            const metadata = billingInfo ? {
              Fe_code: billingInfo.Fe_code,
              Pec: billingInfo.Pec,
              Fiscal_code: billingInfo.Fiscal_code
            } : {}           
            
            lawyer.metadata = metadata 

            lawyer.vat_number = billingInfo ? billingInfo.vat_number : null
          }
          await backendService.put(`/api/lawyers/${curUser.id}`, lawyer)
          NotificationManager.success(Translate(languageContext, 'user_profile_updated'));
        }
        catch(error){
          const mess = Translate(languageContext, error.data.message) ? Translate(languageContext, error.data.message) : Translate(languageContext, 'generic_fail_message');
          NotificationManager.error(mess)
        }

      }
      setIsProcessing(false)
    }

    const preventReturnPropagation = async (event) => {
      if (event.keyCode === 13)
        event.preventDefault()
    }    

    return (
      <>
        <Row>
          <Col xs={10} sm={4} md={3} className='lisia-app-logo-wrapper'>
            <Link to='/'>
              <Image src={ Logo } />
            </Link>
          </Col>
        </Row>
        <Row>
            <Col className="lisia-app-card-content centered" xs={12} sm={7} md={6} lg={5}>    
              <h3 className='text-center'><Text tid='user_profile_user_profile' /></h3>
              <Divider />
              { !loading ?   
              <Form className='pad20'>                
                
                <Form.Group widths='equal'>
                  <Form.Input
                    error={errors.name !== '' ? errors.name : false}
                    label={Translate(languageContext, 'admin_user_profile_first_name')}
                    value={curUser?.name || ''}
                    placeholder={Translate(languageContext, 'admin_user_profile_first_name')}
                    onChange={handleChange}
                    onKeyDown={preventReturnPropagation}
                    name="name" 
                  />                
                  <Form.Input
                    value={curUser?.surname || ''}
                    error={errors.surname !== '' ? errors.surname : false}
                    onChange={handleChange}
                    name="surname"
                    onKeyDown={preventReturnPropagation}
                    label={Translate(languageContext, 'admin_user_profile_last_name')}
                    type="text" placeholder={Translate(languageContext, 'admin_user_profile_last_name')}
                  />
                </Form.Group>
                <Form.Group widths='equal'>
                <Form.Input
                    error={errors.email !== '' ? errors.email : false}
                    fluid
                    label={Translate(languageContext, 'admin_user_profile_email')}
                    value={curUser?.email || ''}
                    onChange={handleChange}
                    onKeyDown={preventReturnPropagation}
                    name="email" 
                    type="email" placeholder={Translate(languageContext, 'admin_user_profile_email')}
                  />
                </Form.Group>
                <Form.Group widths='equal'>
                <Form.Input
                    fluid
                    error={errors.query !== '' ? errors.query : false}
                    label={Translate(languageContext, 'user_profile_queries')}
                    value={curUser?.plan_queries || ''}
                    onChange={handleChange}
                    name="plan_queries" 
                    onKeyDown={preventReturnPropagation}
                    placeholder={Translate(languageContext, 'user_profile_queries')}
                    type="number"
                  />                
                  <SemanticDatepicker 
                    label={Translate(languageContext, 'user_profile_license_expiration')}
                    value={curUser?.license_expire_at && new Date(curUser?.license_expire_at)}
                    onChange={handleDateChange}
                  />
                  
                </Form.Group>
                <Form.Group>
                  <Form.Checkbox onChange={() => setCurUser({...curUser, is_verified: !curUser?.is_verified})} checked={curUser?.is_verified} label={Translate(languageContext,'user_email_verified')} />
                </Form.Group>               
                { 
                  <>
                  <Form.Group>
                  <Form.Checkbox onChange={() => setShowBillingInfo(!showBillingInfo)} checked={showBillingInfo} label={id ? Translate(languageContext,'user_profile_show_billing_info') 
                                                                                                                            : Translate(languageContext,'add_billing_info')} />
                  </Form.Group>
                  {
                    showBillingInfo && 
                    <Accordion>
                      
                        <Accordion.Title
                          active={showBillingInfo}
                          index={0}
                          onClick={() => setShowBillingInfo(!showBillingInfo)}
                          style={{textAlign:'left', fontSize: showBillingInfo ? '1.17em': '', fontWeight: 'bold'}}
                        >                      
                        
                          <div style={{textAlign: 'center', marginTop: '-1.17em'}}>
                            <Text tid='user_profile_billing_info' /> 
                          </div>
                                                                  
                        </Accordion.Title>
                      
                        <Accordion.Content active={showBillingInfo} style={{margin: '10px'}}>     
                          <Divider />              
                          <BillingInfoForm handleStateChange={handleBillingInfoChanged} billingInfo={billingInfo} /> 
                        </Accordion.Content>
                      
                    </Accordion> 
                    }
                  </>
                } 
                                   
                { //add card on new user creation
                !id ?
                  <Button style={{width: '100%'}} disabled={processing || (showBillingInfo && (billingInfo.is_error || !billingInfo.is_data_ok))} className='lisia-blue' onClick={handleResult}>
                    <Text tid='add_user'/>
                  </Button>                
                :  
                <>
                  <Button style={{width: '100%'}} disabled={processing || (showBillingInfo && (billingInfo.is_error || !billingInfo.is_data_ok))} className='lisia-blue' onClick={handleEdit}>
                    <Text tid='submit'/>
                  </Button>

                </>
                }     
                <Divider />        
                <Link to='/adminpage'>
                    <Text tid="back" />
                </Link>
              </Form> : 
                <Loader size='large' inline='centered' active><Text tid="loading" /></Loader>
              }
            </Col>
          </Row>
      </>
    )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  stripeState: state.stripeState,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps)(UserPage)
